<template>
  <div
    id="app"
    :class="{pt170:headerStatus}"
    v-cloak
    v-show="isShow"
  >

    <!-- 头部 -->
    <div
      class="app-header"
      :class="{active:!headerStatus}"
    >
      <div>
        <img
          class="logo"
          :src="`/static/images/${headerStatus?'logo1':'logo'}.png`"
          alt=""
        >
        <div class="header-nav">
          <span
            :class="{active:activeIndex == 1}"
            @click="toUrl('/');activeIndex=1"
          >首页</span>
          <span
            :class="{active:activeIndex == 2}"
            @click="toUrl('/shopkeeper');activeIndex=2"
          >成为店主</span>
          <span
            :class="{active:activeIndex == 3}"
            @click="toUrl('/about');activeIndex=3"
          >关于美购</span>
          <span
            :class="{active:activeIndex == 4}"
            @click="toUrl('/download');activeIndex=4"
          >APP下载</span>
          <p>客服热线：020-3992-1805</p>
        </div>
      </div>
    </div>
    <!-- 头部 -->

    <router-view></router-view>

    <!-- 底部 -->
    <div
      class="app-footer"
      :class="{gray:activeIndex==2}"
    >
      <div
        class="setTop"
        @click="setTop()"
      ></div>
      <div class="footer-box">
        <div class="pull-left">
          <img
            class="footer-logo"
            src="/static/images/footer_logo.png?v=1.00"
            alt=""
          >
          <p class="mt28 mb22 f20">联系我们</p>
          <p class="mb10">
            <span>客服电话: 020-3992-1805 </span>
            <span class="mr0">招商热线: 020-3992-1805 </span>
          </p>
          <p>地址:广州市番禺区番禺大道北555号天安节能科技园23号楼23层</p>
        </div>
        <div class="code pull-right">
          <img
            src="/static/images/public_number.png"
            alt=""
          >
          <p>美购国际公众号</p>
        </div>
        <div class="code pull-right ml0">
          <img
            src="/static/images/wechat.png"
            alt=""
          >
          <p>美购国际官方微信</p>
        </div>
      </div>
      <div class="record-number">
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备18133614号-1</a>
        &nbsp;COPYRIGHT 2018 MEGAOSHOP.COM ALL RIGHTS RESERVED. 美购国际 版权所有<br />
        <div style="width:300px;margin:0 auto; padding:20px 0;">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011302002965" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="/static/images/record-logo.png" style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44011302002965号</p>
          </a>
        </div>
      </div>
    </div>
    <!-- 底部 -->

    <!-- 右侧导航 -->
    <div
      class="app-right-nav"
      v-show="next_page"
    >
      <div class="div"></div>
      <div class="div">

        <div class="code">
          <div class="pull-right">
            <div
              class="img"
              style="background-image:url('/static/images/public_number.png')"
            ></div>
            <!-- <img src="/static/images/public_number.png" alt=""> -->
            <p>美购国际公众号</p>
          </div>
          <div class="pull-right">
            <div
              class="img"
              style="background-image:url('/static/images/wechat.png')"
            ></div>
            <!-- <img src="/static/images/public_number.png" alt=""> -->
            <p>美购国际官方微信</p>
          </div>
        </div>
      </div>
      <div
        class="div"
        @click="setTop()"
      ></div>

    </div>
    <!-- 右侧导航 -->
  </div>
</template>

<style rel="stylesheet/scss" lang="scss">
@import "./assets/sass/common/tool";
@import "./assets/sass/common/base";
#app {
  position: relative;
  padding-top: 110px;
  .app-header {
    width: 100%;
    height: 170px;
    position: fixed;
    overflow: hidden;
    background: #fff;
    top: 0;
    padding-top: 31px;
    border-bottom: 1px solid #ccc;
    left: 0;
    z-index: 998;
    & > div {
      width: 1000px;
      margin: 0 auto;
    }
    &.active {
      height: 110px;
      padding-top: 0;
      padding: 13px 0;

      & > div {
        display: flex;
        // justify-items: center;
        align-items: center;
      }
      .logo {
        width: 180px;
        height: 42px;
      }
      .header-nav {
        text-align: center;
        span {
          margin: 0 15px;
          float: none;
          display: inline-block;
        }
      }
    }
    .logo {
      width: 233px;
      height: 54px;
      display: block;
      margin: 0 auto;
    }
    .header-nav {
      overflow: hidden;
      width: 1000px;
      margin: 0 auto;
      font-size: 18px;
      color: #333;
      line-height: 84px;
      height: 84px;
      span {
        float: left;
        font-size: 18px;
        line-height: 84px;
        color: #333;
        cursor: pointer;
        margin-right: 40px;
        position: relative;
        &.active {
          color: #a22423;
        }
        &::before {
          content: "";
          width: 100%;
          height: 4px;
          background: #a22423;
          position: absolute;
          left: 0;
          transition: all 0.1s;
          bottom: -100%;
        }
        &:hover::before {
          bottom: 20px;
        }
      }
      p {
        float: right;
        line-height: 84px;
      }
    }
  }
  .app-footer {
    padding-top: 45px;
    background-color: #fff;
    position: relative;
    height: 395px;
    z-index: 5;
    width: 100%;
    background-size: cover;
    background-position: center;
    background-image: url("/static/images/footer_back.jpg");

    .footer-box {
      width: 1200px;
      margin: 0 auto;
      color: #fff;
      overflow: hidden;
      padding-top: 32px;
      font-size: 20px;
      .footer-logo {
        width: 260px;
        height: 60px;
      }
      p {
        overflow: hidden;
        font-weight: 100;
        font-size: 16px;
        span {
          margin-right: 75px;
          font-weight: 100;
          font-size: 16px;
        }
      }
      .code {
        margin-left: 120px;
        padding-top: 30px;
        text-align: center;
        img {
          width: 124px;
        }
        p {
          font-size: 16px;
          margin-top: 8px;
        }
      }
    }
    .setTop {
      width: 122px;
      height: 46px;
      cursor: pointer;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      top: 0;
    }
    .record-number {
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      border-top: 1px solid #525252;
      text-align: center;
      font-size: 16px;
      height: 98px;
      color: #fff;
      padding-top: 20px;
    }
  }
  .app-right-nav {
    position: fixed;
    z-index: 998;
    // right: 264px;
    right: 264px;
    // opacity: 0;
    // left: 50%;
    bottom: 325px;

    .div {
      width: 60px;
      height: 60px;
      cursor: pointer;
      margin-bottom: 15px;
      background-size: cover;
      background-position: center;

      &:hover {
        &:nth-child(1) {
          background-image: url("/static/images/kefu1.png");
        }
        &:nth-child(2) {
          background-image: url("/static/images/erweima1.png");
          .code {
            display: block;
          }
        }
        &:nth-child(3) {
          background-image: url("/static/images/zhiding1.png");
        }
      }
      &:nth-child(1) {
        background-image: url("/static/images/kefu.png");
      }
      &:nth-child(2) {
        background-image: url("/static/images/erweima.png");
      }
      &:nth-child(3) {
        background-image: url("/static/images/zhiding.png");
      }
    }
    .code {
      position: absolute;
      overflow: hidden;
      top: 0;
      display: none;
      transform: translate(-100%, 0);
      left: -10px;
      width: 272px;
      height: auto;
      background: rgba(0, 0, 0, 0.7);
      div {
        width: 136px;
        width: 50%;
        text-align: center;
        height: auto;
        padding: 15px 0;
        font-size: 16px;
        color: #fff;
        .img {
          width: 106px;
          height: 106px;
          margin: 0 auto;
          overflow: hidden;
          background-size: cover;
          background-position: center;
        }
        p {
          padding-top: 8px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
<script>
import { LoginStatus } from "hanzi-vue-package";

export default {
  data() {
    return {
      isShow: true, //页面是否显示
      activeIndex: 1,
      headerStatus: true,
      next_page: false, //是否滚动到第二页
      timer: null
    };
  },
  created() {
    let that = this;
    /*
     **混合 （请认真查看使用方法 https://vuefe.cn/v2/guide/mixins.html）
     **注意同名钩子函数将混合为一个数组，因此都将被调用。且先调用混合对象的钩子
     **
     */
    tools.vue.mixin({
      /* 全局方法 */
      methods: {
        /* 跳转 */
        toUrl: function(url, val) {
          tools.router.push({ path: url, query: val });
        }
      }
    });
  },
  name: "app",
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "isLinkChange"
  },
  methods: {
    init() {
      let that = this;
      // $(".app-right-nav").css({
      //   left: window.innerWidth / 2,
      //   opacity: 0
      // });
      // window.onresize = function() {
      //   that.init();
      // };
      // 右侧按钮位置
      // setTimeout(() => {
      //   $(".app-right-nav").css({
      //     left: window.innerWidth / 2 + 600,
      //     opacity: 1
      //   });
      // });
      var t = document.documentElement.scrollTop || document.body.scrollTop;
      // 顶部导航变化
      window.onscroll = function() {
        var winTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        var menTop = 170;
        if (winTop >= menTop) {
          that.headerStatus = false;
        } else {
          that.headerStatus = true;
        }
        if (winTop > window.innerHeight) {
          that.next_page = true;
        } else {
          that.next_page = false;
        }
      };
    },
    /* 连接变化时执行 */
    isLinkChange: function() {
      var that = this;
      //console.log('改变了导航:',this.$route);

      if (!that.isHavePage()) {
        return;
      }
      //判断是否为登陆页
      if (that.$route.path == "/shopkeeper") {
        that.activeIndex = 2;
      } else if (that.$route.path == "/about") {
        that.activeIndex = 3;
      } else if (that.$route.path == "/download") {
        that.activeIndex = 4;
      } else {
        that.activeIndex = 1;
      }
      // if(!(that.$route.path == '/login' || that.$route.path == '/register' || tools.noLoginUrl.isUrl(that.$route.path))){
      //
      //     //每次跳页面都会验证登录是否过期
      //     LoginStatus.check({
      //         type:  'login'
      //     });
      //
      // }

      that.isShow = true;
    },

    /* 判断页面是否存在 */
    isHavePage: function() {
      //首页跳过
      console.log(this.$route);
      if (this.$route.path == "/") {
        return true;
      }

      //首页跳过
      if (this.$route.path == "/404") {
        this.isShow = true;
        return false;
      }

      //注册页跳过
      if (this.$route.path == "/register") {
        this.isShow = true;
        return false;
      }

      //不存在自动跳转到404页面
      if (this.$route.matched.length < 1) {
        tools.router.push("/404");
        return false;
      }
      if (this.$route.query.type) {
        document.documentElement.scrollTop = document.body.scrollTop = 700;
      } else {
        document.documentElement.scrollTop = document.body.scrollTop = 0;
      }

      this.isfullScreen = false;
      return true;
    },

    navBlock: function(type) {
      this.isNavBlock = type;
    },
    setTop() {
      let that = this;
      //  $('html').animate({scrollTop: 0}, 300);
      var oTop = document.body.scrollTop || document.documentElement.scrollTop;
      if (oTop > 0) {
        document.body.scrollTop = document.documentElement.scrollTop =
          oTop - 50;
        that.setTop();
      } else {
      }
    },

    /* 跳转 */
    toUrl: function(url, val) {
      tools.router.push({ path: url, query: val });
    }
  },
  components: {},
  beforeCreate() {},
  mounted() {
    this.isHavePage();
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?3c1ae84f